/* eslint-disable react-hooks/exhaustive-deps */
/* ============================================================
   ใบสั่งงานปิดฉลาก (Label Work Order)

   แถวในตารางดึงจาก BOM ที่มีอยู่แล้ว ไม่ต้องกรอกอะไรเพิ่ม
   ใช้กติกาเดียวกับหน้า Calculate Material
     PG        = จำนวนกล่องของ Job Order
     FG        = จำนวนกล่อง x Unit/cs
     Packaging = qty ใน BOM x จำนวนกล่อง x Unit/cs
     Packing   = qty ใน BOM x จำนวนกล่อง
   มีข้อมูลจริงช่องเดียวคือ "จำนวนเบิก"

   ช่องที่เหลือ (เบิกระหว่างการใช้งาน / Lot NO. / จำนวนเสีย / ยอดคืน)
   เว้นว่างไว้ให้เขียนมือหน้างาน — ตามฟอร์มกระดาษเดิม
   ไม่มีคอลัมน์ Barcode ตามที่ผู้ใช้ระบุ
============================================================ */
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Button, Modal } from "antd";
import dayjs from "dayjs";
import { PiPrinterFill } from "react-icons/pi";

import logo from "../../../assets/images/logo_nsf.png";
import JobOrderService from "../../../service/ERP/JobOrder.service";
import "./jo-label.css";

const joService = JobOrderService();

const num = (v) => Number(v || 0);
const money = (v) =>
  num(v) > 0 ? num(v).toLocaleString("en-US", { maximumFractionDigits: 2 }) : "-";

/* จำนวนแถวขั้นต่ำในตาราง เติมแถวว่างให้ฟอร์มเต็มหน้าเหมือนกระดาษเดิม */
const MIN_ROWS = 8;

export default function JoLabelPrintPreview() {
  const { code } = useParams();

  const [header, setHeader] = useState({});
  const [detail, setDetail] = useState([]);

  const handlePrint = () => window.print();

  /* ฉีดกฎขนาดกระดาษตั้งแต่เปิดหน้า เพราะไฟล์ CSS ของหน้า print อื่น
     ประกาศ @page เป็น global มาในบันเดิลเดียวกัน ถ้าไม่ฉีดทับจะได้ขนาดผิด
     ฉีดตอน mount = อยู่ท้าย cascade จึงชนะ และถอดออกตอนออกจากหน้า */
  useEffect(() => {
    const STYLE_ID = "jo-label-print-page";
    let style = document.getElementById(STYLE_ID);
    if (!style) {
      style = document.createElement("style");
      style.id = STYLE_ID;
      style.media = "print";
      style.innerHTML = "@page { size: A4 landscape; margin: 8mm; }";
      document.head.appendChild(style);
    }
    return () => {
      const s = document.getElementById(STYLE_ID);
      if (s) s.remove();
    };
  }, []);

  useEffect(() => {
    joService
      .labelOrderGet(code)
      .then((res) => {
        const { header: h, detail: d } = res.data?.data || {};
        setHeader(h || {});
        setDetail(d || []);
      })
      .catch((err) => {
        Modal.error({
          title: "Error",
          content: err.response?.data?.message || "โหลดข้อมูลไม่สำเร็จ",
          onOk: () => window.close(),
        });
      });
  }, [code]);

  /* เติมแถวว่างให้ครบขั้นต่ำ + แถวหมายเหตุท้ายฟอร์มตามกระดาษเดิม */
  const blankCount = Math.max(0, MIN_ROWS - detail.length);
  const blanks = Array.from({ length: blankCount }, (_, i) => ({
    _blank: true,
    key: `blank-${i}`,
  }));

  return (
    <div className="jo-label-screen" id="jo-label">
      <div className="jol-toolbar">
        <Button
          className="bn-center bg-blue-400"
          onClick={handlePrint}
          icon={<PiPrinterFill style={{ fontSize: "1.1rem" }} />}
        >
          PRINT
        </Button>
      </div>

      <div className="jol-preview">
        <section className="jol-page">
          {/* เลขที่ฟอร์มควบคุมเอกสาร มุมขวาบนสุดของหน้า */}
          <div className="jol-formno">FM.WH.14/R1</div>

          {/* ── หัวเอกสาร ── */}
          <div className="jol-head">
            <img src={logo} alt="" className="jol-logo" />
            <div className="jol-title">
              <div className="jol-company">บริษัท ไนน์สตาร์ฟู้ด จำกัด</div>
              <div className="jol-doc">ใบสั่งงานปิดฉลาก</div>
            </div>
            <div className="jol-jo">
              <span className="jol-jo-label">Job Order</span>
              <span className="jol-jo-value">{header?.jocode || "-"}</span>
            </div>
          </div>

          {/* ── ข้อมูลประกอบ ── */}
          <div className="jol-meta">
            <span>
              <b>ลูกค้า :</b> {header?.cusname || "-"}
            </span>
            <span>
              <b>Brand :</b> {header?.brand || "-"}
            </span>
            <span>
              <b>วันที่ JO :</b>{" "}
              {header?.jodate ? dayjs(header.jodate).format("DD/MM/YYYY") : "-"}
            </span>
            <span>
              <b>จำนวนกล่อง :</b> {money(header?.carton)}
            </span>
          </div>

          {/* ── ตารางรายการ ── */}
          <table className="jol-tbl">
            <colgroup>
              <col style={{ width: "15%" }} />
              <col style={{ width: "31%" }} />
              <col style={{ width: "9%" }} />
              <col style={{ width: "11%" }} />
              <col style={{ width: "10%" }} />
              <col style={{ width: "7%" }} />
              <col style={{ width: "8.5%" }} />
              <col style={{ width: "8.5%" }} />
            </colgroup>
            <thead>
              <tr>
                <th rowSpan={2}>Code โค้ด</th>
                <th rowSpan={2}>Name ชื่อ</th>
                <th rowSpan={2} className="jol-th-sm">
                  เบิกระหว่าง
                  <br />
                  การใช้งาน
                </th>
                <th rowSpan={2}>Lot NO.</th>
                <th colSpan={4}>บันทึก</th>
              </tr>
              <tr>
                <th className="jol-th-sm">จำนวนเบิก</th>
                <th className="jol-th-sm">หน่วย</th>
                <th className="jol-th-sm">จำนวนเสีย</th>
                <th className="jol-th-sm">ยอดคืน</th>
              </tr>
            </thead>
            <tbody>
              {detail.map((r, i) => (
                <tr
                  key={`${r.mat_code}-${i}`}
                  className={Number(r.is_product) === 1 ? "jol-row-product" : ""}
                >
                  <td className="jol-code">{r.mat_code || ""}</td>
                  <td className="jol-name">{r.mat_name || ""}</td>
                  <td />
                  <td />
                  {/* ช่องเดียวที่ระบบเติมค่าให้ — คำนวณจาก BOM */}
                  <td className="jol-qty">{money(r.issue_qty)}</td>
                  <td className="jol-unit">{r.unit || ""}</td>
                  <td />
                  <td />
                </tr>
              ))}

              {blanks.map((b) => (
                <tr key={b.key} className="jol-row-blank">
                  <td>&nbsp;</td>
                  <td />
                  <td />
                  <td />
                  <td className="jol-qty">-</td>
                  <td />
                  <td />
                  <td />
                </tr>
              ))}

              {/* แถวหมายเหตุท้ายฟอร์ม ตามกระดาษเดิม */}
              <tr>
                <td />
                <td className="jol-note">รูปแบบการ Ink</td>
                <td />
                <td />
                <td />
                <td />
                <td />
                <td />
              </tr>
              <tr>
                <td />
                <td className="jol-note">ปั้ม Code ข้างกล่อง</td>
                <td />
                <td />
                <td />
                <td />
                <td />
                <td />
              </tr>
            </tbody>
          </table>

          {/* ── ช่องลงชื่อท้ายฟอร์ม ── */}
          <div className="jol-sign">
            <span>ผู้บันทึก__________</span>
            <span>วันที่ปิดฉลาก__________</span>
            <span>รหัสสินค้า/โค้ดผลิต__________</span>
            <span>แบทช์__________</span>
            <span>ลักษณะสติ๊กเกอร์แผ่นหลัง/ซอง__________</span>
            <span>เลขท้ายบาร์โค้ด__________</span>
          </div>
        </section>
      </div>
    </div>
  );
}
